import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, retry, throwError } from 'rxjs';
import { NotificationService } from '../services/notification.service';
import { AppConfigService } from '../config/app-config.service';

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const notify  = inject(NotificationService);
  const config  = inject(AppConfigService);
  const maxRetry = config.get('maxRetryAttempts') ?? 3;

  const empPortalBaseUrl = config.get('empPortalBaseUrl');
  const isEmpPortal = empPortalBaseUrl && req.url.includes(empPortalBaseUrl);

  const isIdempotent = ['GET', 'HEAD'].includes(req.method) && !isEmpPortal;

  return next(req).pipe(
    isIdempotent ? retry({ count: maxRetry, delay: 1000 }) : (src => src),
    catchError((error: HttpErrorResponse) => {
      if (error.status === 0) {
        notify.error('Network error. Please check your connection.');
      } else if (error.status >= 500) {
        let errMsg = 'Server error. Please try again later.';
        if (error.error) {
          let rawMsg = '';
          if (typeof error.error === 'string') {
            const trimmed = error.error.trim();
            if (trimmed.startsWith('{') && trimmed.endsWith('}')) {
              try {
                const parsed = JSON.parse(trimmed);
                rawMsg = parsed._embedded?.errors?.[0]?.message || parsed.message || parsed.error || '';
              } catch (e) {
                if (!trimmed.startsWith('<')) {
                  rawMsg = trimmed;
                }
              }
            } else if (!trimmed.startsWith('<')) {
              rawMsg = trimmed;
            }
          } else if (typeof error.error === 'object') {
            rawMsg = error.error._embedded?.errors?.[0]?.message || error.error.message || error.error.error || '';
          }

          if (rawMsg) {
            errMsg = rawMsg.replace(/^(internal\s+server\s+error:\s*)/i, '').trim();
          }
        }
        notify.error(errMsg);
      } else if (error.status === 403) {
        notify.error('You do not have permission to perform this action.');
      } else if (error.status === 404) {
        const isSelfHandled = req.url.includes('/performance/categories/self');
        if (!isSelfHandled) {
          notify.error('The requested resource was not found.');
        }
      }
       else if (error.status === 409) {
        notify.error(error.error?.message);
      }
      return throwError(() => error);
    })
  );
};
